import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExportInterface } from 'app/models/export.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { ExportDataTransformPost } from './data-transforms/export.data.transform.post';
import { ExportDataTransformGet } from './data-transforms/export.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class ExportHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/logexports(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformDown: ExportDataTransformPost,
    private readonly _transformUp: ExportDataTransformGet,
  ) {}

  intercept(req: HttpRequest<ExportInterface>, next: HttpHandler): Observable<HttpEvent<ExportInterface>> {
    return RequestService.getTransformedHttpEvent<ExportInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
